import styled, { css } from 'styled-components/macro'

import { getToken, toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

export const CardWrapper = styled.div`
  background-color: ${toCSSValue('color-background-primary')};
  border: ${getToken('border-thin')} solid ${toCSSValue('color-border')};
  border-radius: ${getToken('border-radius-s')};
`

export const DeadlineWrapper = styled.div`
  padding: ${getToken('spacing-3')} ${getToken('spacing-6')};
  border-bottom: ${getToken('border-thin')} solid ${toCSSValue('color-border')};
`

const BodyStyle = css`
  display: flex;
  flex-direction: column;
  padding: ${getToken('spacing-6')};
`

export const DesktopBodyWrapper = styled.div`
  ${BodyStyle}
  gap: ${getToken('spacing-4')};
`

export const MobileBodyWrapper = styled.div`
  ${BodyStyle}
  gap: ${getToken('spacing-6')};
`

export const MobileShipperRateWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  > :nth-child(1) {
    flex-basis: 50%;
    flex-grow: 1;
  }

  > :nth-child(2) {
    justify-content: center;
  }
`
